export function toTitleCase(input: string | null) {
  if (!input) return;
  return input.toLowerCase().replace(/\b(\w)/g, char => char.toUpperCase());
}
